import { useFetcher } from '@f-technology-srl/client-authorization';
import { useHandleRespError } from '@f-technology-srl/react-hook-utils';
import { AnalysisResultDto } from '@observatory/shared/gard/dtos';
import useSWR from 'swr';

export const useAnalysisResult = (banchMarkResultId: string) => {
  const fetcher = useFetcher();
  const { error: actionError, handle } = useHandleRespError(false);

  const { data, error, mutate } = useSWR<AnalysisResultDto>(
    `/api/rate-calculation/simple/${banchMarkResultId}`,
    fetcher
  );

  return {
    data: handle(data),
    isLoading: !error && !data,
    isError: !!(error || actionError),
    errorMessage: actionError,
    mutate,
  };
};
